import React from 'react';
import { Eyebrow } from './Eyebrow';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  intro?: string;
  tone?: 'ink' | 'cream';
  align?: 'left' | 'center';
  className?: string;
  children?: React.ReactNode;
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'ink',
  align = 'left',
  className = '',
  children
}: SectionHeadingProps) {
  const isCream = tone === 'cream';
  return <div className={`${align === 'center' ? 'mx-auto max-w-2xl text-center' : ''} ${className}`} data-id="element-271" data-mp="mzgat7xz3hwu">
      {eyebrow && <Eyebrow className="text-brick" data-id="element-272" data-mp="i6n3ccb4dvh2">{eyebrow}</Eyebrow>}
      <h2 className={`mt-4 font-serif text-4xl leading-[1.08] md:text-[3.25rem] ${isCream ? 'text-ink-deep' : 'text-ink'}`} data-id="element-273" data-mp="d83g88ksidn4">
        {title}
      </h2>
      {intro && <p className={`mt-5 max-w-xl text-base leading-relaxed ${align === 'center' ? 'mx-auto' : ''} ${isCream ? 'text-ink-soft' : 'text-ink-soft'}`} data-id="element-274" data-mp="475druq02e6n">
          {intro}
        </p>}
      {children}
    </div>;
}